/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import getHistory from '../../lib/HistoryHelper';
import { trackLink } from '../../lib/analytics-helper';
import { FAQ_ARTICLE } from '../../contactUs/constants/PropTypesShapes';
import Page from '../../lib/page';

const directMapping = {
  ltr: 'right',
  rtl: 'left',
};

const Breadcrumb = (props) => {
  const { items, action } = props;
  const history = getHistory();

  const push = (element, key, updateBreadcrumb) => {
    const breadcrumb = items.slice(0, key + 1);
    if (updateBreadcrumb) {
      updateBreadcrumb(breadcrumb);
    }

    const FPTIId = Page.getFPTIPageId(); // Bread Crumb is Used for both Topic and article page
    trackLink({ id: FPTIId, link: `smarthelp-hcr-breadcrumb|${element.title}` });
    history.push(`${element.path}`);
  };

  const handleKeyPress = (event, item, key, actions) => {
    if (event.which === 13) {
      push(item, key, actions);
    }
  };

  // Update breadcrumb arrow style by wwebpage direction
  const arrowIcon = () => {
    const direction = directMapping[Page.getDirection()];

    return (
      <span className={`vx_icon vx_icon-small vx_icon-arrow-${direction}-small breadcrumb-item__arrow`} aria-hidden="true" />
    );
  };

  const renderBreadCrumb = () => {
    const itemList = items.map((item, key) => {
      const attrs = {
        className: 'breadcrumb-item-content',
        href: `/${Page.getCountry()}/smarthelp${item.path}`,
        onClick: (e) => { e.preventDefault(); push(item, key, action); },
        onKeyPress: (e) => handleKeyPress(e, item, key, action),
      };

      if (key === items.length - 1) {
        // Adding aria-current for the last breadcrumb link based on https://www.w3.org/TR/wai-aria-practices/#breadcrumb
        attrs['aria-current'] = 'page';
      }

      return (
        <li
          className="breadcrumb-item"
          key={item.title}
        >
          <a {...attrs}>
            <span className="article-breadcrumb-title">{item.title}</span>
          </a>
          {arrowIcon()}
        </li>
      );
    });

    return <ul className="article-breadcrumb-path">{itemList}</ul>;
  };

  return (
    <div className="article-breadcrumb" role="navigation" aria-label="Breadcrumb">
      {renderBreadCrumb()}
    </div>
  );
};

Breadcrumb.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape(FAQ_ARTICLE)),
  action: PropTypes.func,
};
Breadcrumb.defaultProps = {
  items: [],
  action: undefined,
};

export default Breadcrumb;
